import React, { useEffect, useRef } from 'react';
import './Hero.css';
import heroCover from '../assets/YOCILAB Webiste photos/YOCILAB Home page/Home Cover 1.jpg';

const Hero = () => {
  const heroRef = useRef(null);
  const textRef = useRef(null);

  // Parallax effect on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const scrollY = window.scrollY;
        heroRef.current.style.transform = `translateY(${scrollY * 0.35}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Animate text on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      if (textRef.current) {
        textRef.current.classList.add('hero__content--visible');
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToContent = () => {
    const el = document.getElementById('what-we-do');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      {/* Background Image with Parallax */}
      <div className="hero__bg-wrapper">
        <img
          ref={heroRef}
          src={heroCover}
          alt="Young Africans at YOCILAB"
          className="hero__bg-img"
        />
        <div className="hero__overlay" />
      </div>

      {/* Content pinned to bottom */}
      <div className="hero__content" ref={textRef}>
        <div className="container">
          <div className="hero__bottom-row">
            <h1 className="hero__title hero__title--tagline">
              Empowering young Africans with skills, networks, and opportunities<br />
              <em>to design solutions that create jobs and scale impact.</em>
            </h1>

            <button className="hero__cta" onClick={scrollToContent}>
              <span className="hero__cta-arrow">
                <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              What We Do
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
